{
  "zh-TW": {
    "messages": {
      "plaqueTool": {
        "attached": "%{vehicle} 現已帶有此銘牌。",
        "hangarFailure": "無法載入你的機庫。",
        "createFailure": "無法將這艘艦船加入你的機庫。",
        "addedWithoutPlaque": "艦船已加入你的機庫，但無法儲存其銘牌。請重試以放上銘牌。",
        "replaceConfirm": "這艘艦船已有銘牌。要替換嗎？"
      },
      "blueprint": {
        "own": { "success": "%{blueprint} 已標記為已擁有" },
        "unown": { "success": "%{blueprint} 不再標記為已擁有" },
        "want": { "success": "%{blueprint} 已加入你的願望清單" },
        "unwant": { "success": "%{blueprint} 已從你的願望清單移除" }
      },
      "fleetchartScreenshot": {
        "failure": "艦隊圖表未能儲存為圖片"
      },
      "buyback": {
        "destroy": {
          "failure": "無法移除該回購承諾。"
        }
      },
      "hangarShare": {
        "enable": {
          "success": "分享連結已建立。",
          "failure": "無法建立分享連結。"
        },
        "rotate": {
          "success": "分享連結已重設，舊連結已失效。",
          "failure": "無法重設分享連結。",
          "confirm": "重設後目前的連結將失效。你分享過的人需要使用新連結。"
        },
        "disable": {
          "success": "分享連結已刪除。",
          "failure": "無法刪除分享連結。",
          "confirm": "刪除後，所有收到此連結的人都將無法再使用它。"
        },
        "copy": {
          "success": "分享連結已複製到剪貼簿。",
          "failure": "無法複製分享連結。"
        }
      },
      "loading": "載入中…",
      "copy": {
        "success": "文本已複製！",
        "failure": "無法複製文本"
      },
      "copyGitRevision": {
        "success": "Git 版本已複製！",
        "failure": "無法複製 Git 版本"
      },
      "copyImageUrl": {
        "success": "圖片鏈接已複製！",
        "failure": "無法複製圖片鏈接"
      },
      "copyVideoUrl": {
        "success": "視頻鏈接已複製！",
        "failure": "無法複製視頻鏈接"
      },
      "copyShareUrl": {
        "success": "鏈接 \"%{url}\" 已複製！",
        "failure": "無法複製鏈接"
      },
      "copyInviteUrl": {
        "success": "邀請鏈接 \"%{url}\" 已複製！",
        "failure": "無法複製邀請鏈接"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "配置網址已複製！",
        "failure": "無法複製配置網址"
      },
      "copyBackupCodes": {
        "success": "備份代碼已複製！",
        "failure": "無法複製備份代碼"
      },
      "signup": {
        "success": "<b>歡迎來到FleetYards.net！</b> 您的帳戶已建立。<br>您將收到一封確認郵件以啟用您的帳戶。",
        "invalid": "請解決錯誤後再建立帳戶。",
        "failure": "我們無法建立您的帳戶。請稍後再試。"
      },
      "accountConfirm": {
        "success": "您的帳戶已成功確認。<br>您現在可以登入。",
        "failure": "您的帳戶無法確認。"
      },
      "requestPasswordChange": {
        "success": "如果您的電子郵件地址存在於我們的資料庫中，您將在幾分鐘內收到密碼重置連結。"
      },
      "changePassword": {
        "success": "您的密碼已成功更改。",
        "failure": "您的密碼無法更新。"
      },
      "modelModule": {
        "update": {
          "failure": "無法儲存模組。"
        }
      },
      "updateProfile": {
        "success": "個人資料已更新。",
        "failure": "個人資料無法更新。"
      },
      "updateHangar": {
        "failure": "無法更新機庫設定。",
        "success": "機庫設定已更新。"
      },
      "updatePrivacy": {
        "success": "隱私設定已更新。"
      },
      "features": {
        "updated": "功能已更新。",
        "error": "無法更新功能。",
        "actorAdded": "角色已新增到功能。",
        "actorRemoved": "角色已從功能中移除。",
        "groupAdded": "群組已新增到功能。",
        "groupRemoved": "群組已從功能中移除。",
        "created": "功能已建立。",
        "destroyed": "功能已移除。"
      },
      "rsiRequestLogs": {
        "resolved": "請求日誌已標記為已解決。",
        "error": "無法更新請求日誌。"
      },
      "updateNotifications": {
        "success": "通知設定已更新。",
        "failure": "無法儲存您的通知設定。"
      },
      "pushNotifications": {
        "failure": "無法更新推播通知。"
      },
      "updateAccount": {
        "success": "帳戶已更新。"
      },
      "oauthApplications": {
        "create": {
          "success": "OAuth 應用程式已建立。",
          "error": "無法建立 OAuth 應用程式。"
        },
        "update": {
          "success": "OAuth 應用程式已更新。",
          "error": "無法更新 OAuth 應用程式。"
        },
        "destroy": {
          "success": "OAuth 應用程式已刪除。",
          "error": "無法刪除 OAuth 應用程式。"
        },
        "regenerateSecret": {
          "success": "客戶端密鑰已重新產生。",
          "error": "無法重新產生客戶端密鑰。"
        },
        "copied": "已複製到剪貼簿。",
        "copyError": "無法複製到剪貼簿。",
        "secretWarning": "請立即複製客戶端密鑰。您將無法再次檢視。"
      },
      "hangarImport": {
        "success": "匯入完成",
        "partialSuccess": "匯入部分完成。<br><br>未找到的飛船：<br>%{missing}",
        "failure": "匯入失敗",
        "queued": "匯入已排入佇列。你可以在此追蹤進度。"
      },
      "hangarExport": {
        "failure": "匯出失敗，請稍後再試。"
      },
      "vehicle": {
        "move": {
          "failure": "無法儲存順序。"
        },
        "add": {
          "success": {
            "noHtml": "您的新%{model}將送達您的機庫",
            "paragraph1": "您的新",
            "paragraph2": "將送達您的"
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "您的新%{model}已新增至您的願望清單",
            "paragraph2": "已新增至您的"
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "已將所有遊戲內購買的飛船移至您的願望清單。",
            "failure": "無法將所有遊戲內購買的飛船移至您的願望清單。"
          },
          "removeAll": {
            "confirm": "要從機庫移除所有在遊戲內購買的飛船嗎？此操作無法復原。",
            "success": "已從您的機庫移除所有遊戲內購買的飛船。",
            "failure": "無法從您的機庫移除所有遊戲內購買的飛船。"
          }
        }
      },
      "itemViews": {
        "syncStarted": "視圖同步已開始。渲染圖附加完成後，請重新整理頁面查看。"
      },
      "model": {
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "塗裝匯入已開始。完成後會通知您。",
        "syncShipViewsStarted": "艦船視圖同步已開始。新的渲染圖處理完成後會顯示在這裡。",
        "dimensionsDrifted": "這些尺寸與遊戲檔案不一致。"
      },
      "announcement": {
        "created": "公告已建立。",
        "updated": "公告已更新。",
        "destroyed": "公告已刪除。",
        "destroyFailed": "無法刪除公告。",
        "createFailed": "無法建立公告。",
        "updateFailed": "無法更新公告。",
        "testSent": "測試已發送到管理員 Discord 頻道。",
        "testFailed": "無法發送測試。",
        "published": "公告已開始發送。",
        "publishFailed": "無法發送公告。",
        "retryQueued": "投遞已重新排入佇列。",
        "retryFailed": "無法重試此次投遞。",
        "refreshQueued": "正在重新整理數據。",
        "refreshFailed": "無法重新整理數據。"
      },
      "fundingGoal": {
        "created": "募資目標已建立。",
        "updated": "募資目標已更新。",
        "destroyed": "募資目標已刪除。",
        "createFailed": "無法建立募資目標。",
        "updateFailed": "無法更新募資目標。"
      },
      "homepageSetting": {
        "updated": "首頁已儲存。",
        "updateFailed": "無法儲存首頁。"
      },
      "gameEvent": {
        "created": "遊戲活動已建立。",
        "updated": "遊戲活動已更新。",
        "destroyed": "遊戲活動已刪除。",
        "createFailed": "無法建立遊戲活動。",
        "updateFailed": "無法更新遊戲活動。"
      },
      "supporterNomination": {
        "update": {
          "success": "艦隊選擇已更新。",
          "failure": "無法更新艦隊選擇。"
        },
        "change": {
          "confirm": "%{fleet} 可能會失去目前擁有的艦隊功能。是否繼續？"
        }
      },
      "supporterContribution": {
        "created": "支持者捐助已建立。",
        "updated": "支持者捐助已更新。",
        "destroyed": "支持者捐助已刪除。",
        "createFailed": "無法建立支持者捐助。",
        "updateFailed": "無法更新支持者捐助。"
      },
      "notification": {
        "granted": "歡迎使用FleetYards.net通知！"
      },
      "twoFactor": {
        "invalidCode": "此驗證碼無效。",
        "enable": {
          "success": "雙因素驗證已啟用！",
          "failure": "無法啟用雙因素驗證。"
        },
        "disable": {
          "success": "雙因素驗證已停用！",
          "failure": "無法停用雙因素驗證。"
        },
        "backupCodes": {
          "failure": "無法生成備份代碼。"
        }
      },
      "error": {
        "usernameTaken": "使用者名稱已被使用。",
        "userNotFound": "找不到使用者",
        "emailTaken": "電子郵件已被使用。",
        "fleetTaken": "艦隊名稱已被使用。",
        "colorInvalid": "顏色無效",
        "serialTaken": "序號已被使用。",
        "textInvalid": "%{field}無效",
        "fleetNameInvalid": "%{field}只能包含字母、數字、空格、點、連字號和底線",
        "vehicleSerialInvalid": "%{field}必須符合遊戲中顯示的註冊編號格式，例如 L8-4261-HA",
        "hangar": {
          "accountRequired": {
            "noHtml": "您需要註冊或登入以新增飛船至您的機庫。",
            "paragraph1": "您需要",
            "paragraph2": "以新增飛船至您的機庫。",
            "paragraph3": "取得更多資訊"
          }
        },
        "blueprint": {
          "accountRequired": "註冊或登入後即可記錄你擁有的藍圖。",
          "update": "無法更新該藍圖，請稍後再試。"
        },
        "default": "<b>發生了錯誤。</b><br>您試過重新啟動嗎？"
      },
      "account": {
        "destroy": {
          "success": "<b>您的帳戶已刪除。</b><br>很遺憾看到您離開 :'(",
          "failure": "我們無法刪除您的帳戶！請稍後再試。"
        },
        "calendarSubscription": {
          "enable": {
            "success": "個人行事曆訂閱已啟用。",
            "failure": "無法啟用行事曆訂閱。"
          },
          "rotate": {
            "success": "個人行事曆連結已更換。現有訂閱者在重新訂閱前將不會再收到更新。",
            "failure": "無法更換個人行事曆連結。",
            "confirm": "更換連結會讓訂閱目前網址的行事曆應用程式在沒有任何提示的情況下失效。您需要用新連結重新訂閱。"
          },
          "disable": {
            "success": "個人行事曆訂閱已停用。",
            "failure": "無法停用個人行事曆訂閱。",
            "confirm": "停用訂閱會中斷目前所有已訂閱的行事曆應用程式的資料來源。"
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "金鑰已複製。",
            "failure": "無法複製金鑰。"
          }
        }
      },
      "user": {
        "destroy": {
          "success": "使用者已刪除。",
          "failure": "無法刪除使用者。"
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "申領已提交，已通知持有該 ID 的艦隊。",
            "failure": "無法申領該艦隊 ID。"
          },
          "destroy": {
            "success": "申領已撤回。",
            "failure": "無法撤回申領。"
          },
          "endNow": {
            "success": "寬限期已結束。",
            "failure": "無法結束寬限期。"
          },
          "cancel": {
            "success": "申領已取消。",
            "failure": "無法取消申領。"
          }
        },
        "create": {
          "success": "您的艦隊已建立。",
          "failure": "艦隊無法儲存。"
        },
        "update": {
          "success": "設定已儲存。",
          "failure": "設定無法儲存。"
        },
        "destroy": {
          "success": "您的艦隊已刪除。",
          "failure": "我們無法刪除您的艦隊。"
        },
        "leave": {
          "success": "您已離開艦隊。",
          "failure": "無法離開艦隊。"
        },
        "invites": {
          "accept": {
            "success": "邀請已接受。",
            "failure": "無法接受邀請。"
          },
          "decline": {
            "success": "邀請已拒絕。",
            "failure": "無法拒絕邀請。"
          },
          "create": {
            "failure": "無法邀請使用者。"
          }
        },
        "members": {
          "update": {
            "success": "設定已儲存。",
            "failure": "設定無法儲存。"
          },
          "destroy": {
            "success": "成員已移除。",
            "failure": "成員無法移除。"
          },
          "demote": {
            "success": "成員已降級。",
            "failure": "成員無法降級。"
          },
          "promote": {
            "success": "成員已升級。",
            "failure": "成員無法升級。"
          },
          "accept": {
            "success": "成員已接受。",
            "failure": "成員無法接受。"
          },
          "decline": {
            "success": "成員已拒絕。",
            "failure": "成員無法拒絕。"
          },
          "nickname": {
            "success": "暱稱已儲存。",
            "failure": "無法儲存暱稱。"
          }
        },
        "roles": {
          "update": {
            "success": "角色已儲存。",
            "failure": "無法儲存角色。"
          }
        },
        "squadrons": {
          "create": {
            "success": "中隊已建立。",
            "failure": "無法建立中隊。"
          },
          "update": {
            "success": "中隊已儲存。",
            "failure": "無法儲存中隊。"
          },
          "destroy": {
            "confirm": "確定要解散中隊「%{name}」嗎？其成員仍留在艦隊中。",
            "success": "中隊已解散。",
            "failure": "無法解散中隊。"
          },
          "sort": {
            "failure": "無法儲存排序。"
          },
          "ranks": {
            "update": {
              "success": "中隊職級已儲存。",
              "failure": "無法儲存中隊職級。"
            }
          },
          "members": {
            "add": {
              "success": "已新增 %{count} 位成員。",
              "failure": "有 %{count} 位成員無法新增。"
            },
            "destroy": {
              "confirm": "要將 %{username} 移出 %{squadron} 中隊嗎？該成員仍留在艦隊中。",
              "success": "已將成員移出中隊。",
              "failure": "無法移除該成員。"
            }
          },
          "join": {
            "success": "你已加入該團隊。",
            "failure": "無法加入該團隊。"
          },
          "leave": {
            "confirm": "退出 %{squadron} 中隊？你仍會留在艦隊中。",
            "success": "你已退出該中隊。",
            "failure": "無法退出該中隊。"
          },
          "requests": {
            "create": {
              "success": "申請已送出，中隊負責人將進行處理。",
              "failure": "無法送出申請。"
            },
            "withdraw": {
              "success": "申請已撤回。",
              "failure": "無法撤回申請。"
            },
            "blocked": {
              "member": "你已在 %{squadron} 中。請先退出，再申請加入其他中隊。",
              "requested": "你已申請加入 %{squadron}。請先撤回該申請，再申請其他中隊。"
            },
            "accept": {
              "success": "%{username} 已加入該中隊。",
              "failure": "無法接受該申請。"
            },
            "decline": {
              "success": "申請已拒絕。",
              "failure": "無法拒絕該申請。"
            }
          },
          "rank": {
            "success": "職級已變更。",
            "failure": "無法變更職級。"
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "行事曆訂閱已啟用。",
            "failure": "無法啟用行事曆訂閱。"
          },
          "rotate": {
            "success": "訂閱連結已更換。現有訂閱者在重新訂閱前將不會再收到更新。",
            "failure": "無法更換訂閱連結。",
            "confirm": "更換連結會讓訂閱目前網址的行事曆應用程式在沒有任何提示的情況下失效。他們需要用新連結重新訂閱。"
          },
          "disable": {
            "success": "行事曆訂閱已停用。",
            "failure": "無法停用行事曆訂閱。",
            "confirm": "停用訂閱會中斷目前所有已訂閱的行事曆應用程式的資料來源。"
          },
          "copy": {
            "success": "行事曆連結已複製。請將它貼到您的行事曆應用程式的\"訂閱行事曆\"或\"以網址新增\"中。",
            "failure": "無法複製行事曆連結。"
          }
        }
      },
      "fleetInvite": {
        "used": "<b>已發送加入%{fleet}的申請！</b><br>一旦您的會員資格被接受，您將收到電子郵件通知",
        "failure": "邀請無法使用。",
        "confirm": "您確定要加入艦隊：\"%{fleet}\"嗎？"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "我們無法載入請求的3D模型！請稍後再試。"
        },
        "webglNotSupported": "此裝置無法使用 3D 檢視器。",
        "tooLarge": "此 3D 模型大小為 %{size} MB，對此裝置而言可能過大。"
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicleLoadout": {
          "moduleContents": {
            "one": "此模組中安裝的部件將一併移除。",
            "other": "此模組中安裝的 %{count} 個部件將一併移除。"
          }
        },
        "vehicle": {
          "destroy": "您確定要從機庫移除此飛船嗎？"
        },
        "buyback": {
          "destroy": "要從回購列表移除此承諾嗎？請在 RSI 上回購後使用。若它仍在 RSI 列表中，下次同步會將其恢復。"
        },
        "hangarGroup": {
          "destroy": "您確定要從機庫移除此群組嗎？"
        },
        "hangar": {
          "import": "匯入的飛船將新增至您的機庫，不會與現有飛船匹配。<br><br>支援的格式為：Fleetyards匯出、Starship42或HangarXplor。<br><br>您要繼續嗎？",
          "destroySelected": "您確定要從機庫移除所有選中的飛船嗎？此操作無法復原。",
          "destroyAll": "您確定要從機庫移除所有飛船嗎？此操作無法復原。",
          "destroyAllTitle": "移除所有飛船？"
        },
        "wishlist": {
          "destroyAll": "您確定要從願望清單移除所有飛船嗎？此操作無法復原。"
        },
        "account": {
          "destroy": "您確定要刪除您的帳戶嗎？此操作無法復原。",
          "destroyWithFleets": "您是以下艦隊的管理員：%{fleets}。刪除帳戶也會一併解散這些艦隊並移除其所有成員。此操作無法復原。要繼續嗎？"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "您確定要離開艦隊嗎？此操作無法復原。",
          "destroy": "您確定要刪除您的艦隊嗎？此操作無法復原。",
          "members": {
            "destroy": "您確定要移除此成員嗎？",
            "remove": "確定要將該成員從艦隊中移除嗎？"
          },
          "invites": {
            "decline": "您確定要拒絕此邀請嗎？此操作無法復原。"
          }
        },
        "oauthApplication": {
          "destroy": "確定要刪除此 OAuth 應用程式嗎? 此操作無法撤銷。",
          "regenerateSecret": "確定要重新產生客戶端密鑰嗎? 現有整合將停止運作。"
        },
        "twoFactor": {
          "generateBackupCodes": "您確定要重新生成雙因素備份代碼嗎？"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "此使用者是以下艦隊的管理員：%{fleets}。刪除該使用者也會一併解散這些艦隊並移除其所有成員。此操作無法復原。要繼續嗎？"
        },
        "itemViews": {
          "sync": "確定要從渲染儲存桶同步此物品的視圖嗎？新的和已變更的渲染圖會被附加，已移除的會恢復。手動上傳以取代已匯入渲染圖的視圖將保留。"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "確定要從機庫資料匯入此型號的塗裝嗎？來源若將某個塗裝標示為整個系列共用，該系列的每個型號都會匯入這個塗裝。",
          "syncShipViews": "確定要從渲染儲存桶同步此型號的艦船視圖嗎？新的和已變更的渲染圖會被附加，已移除的會恢復。手動上傳以取代已匯入渲染圖的視圖將保留。",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "確定要重新載入塗裝嗎？這會排入背景工作。",
          "reloadModules": "確定要重新載入模組嗎？這會排入背景工作。",
          "reloadLoaners": "確定要重新載入借用船嗎？這會排入背景工作。"
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "announcement": {
          "publish": "確定要把這則公告發送到 %{channels} 嗎？發送後無法收回。",
          "destroy": "確定要刪除這則公告嗎？此操作無法復原。"
        },
        "fundingGoal": {
          "destroy": "確定要刪除此募資目標嗎？此操作無法復原。"
        },
        "gameEvent": {
          "destroy": "確定要刪除此遊戲活動嗎？此動作無法復原。"
        },
        "supporterContribution": {
          "destroy": "確定要刪除此支持者捐助嗎？此操作無法復原。"
        },
        "modelPosition": {
          "destroy": "確定要刪除此職位嗎？此操作無法復原。"
        },
        "modelLoaner": {
          "destroy": "確定要刪除此借用船嗎? 此操作無法撤銷。"
        },
        "modelSnubCraft": {
          "destroy": "確定要刪除此 Snub Craft 嗎？此操作無法復原。"
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dockCapacity": {
          "destroy": "確定要刪除此容量條目嗎？此操作無法復原。"
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "確定要刪除所有通知嗎？此操作無法復原。",
          "destroySelected": {
            "one": "確定要刪除選取的通知嗎？此操作無法復原。",
            "other": "確定要刪除選取的 %{count} 則通知嗎？此操作無法復原。"
          }
        },
        "adminFleetFidClaim": {
          "endNow": "立即結束寬限期？持有者將被改名，申領方立刻取得該艦隊 ID。",
          "cancel": "取消此申領？雙方艦隊都會收到通知，持有者保留該艦隊 ID。"
        },
        "fleetFidClaim": {
          "create": "申領艦隊 ID %{fid}？持有它的艦隊會立即收到通知，並在 14 天後失去該 ID，除非它自行證明該 RSI 組織。"
        },
        "adminDestroyedFleet": {
          "restore": "確定要還原此艦隊嗎？",
          "restorePurged": "確定要還原這個已清除的艦隊嗎？還原只能盡力而為：角色、圖片、邀請連結與艦隊載具不會被還原。"
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "確定要刪除所有通知嗎？此操作無法復原。",
          "destroySelected": {
            "one": "確定要刪除選取的通知嗎？此操作無法復原。",
            "other": "確定要刪除選取的 %{count} 則通知嗎？此操作無法復原。"
          }
        },
        "unlistedModel": {
          "createModel": "根據 %{name} 建立飛船？下次 sc_data 載入會補齊其資料。"
        },
        "import": {
          "cleanup": "將此匯入標記為失敗？僅在工作確實已經消失時才這樣做——仍在執行的工作會在結束時報錯。",
          "cleanupSelected": "將所選匯入標記為失敗？只影響仍在執行的那些，確實仍在執行的工作會在結束時報錯。",
          "cancel": "要停止這次匯入嗎？已新增的艦船會保留。"
        },
        "hardpoint": {
          "destroy": "確定要刪除此掛載點嗎？此操作無法復原。"
        },
        "fleets": {
          "contractItem": {
            "destroy": "要從合約中移除這些貨物嗎？"
          }
        },
        "vehicleLog": {
          "destroy": "確定要刪除這則日誌條目嗎？"
        }
      },
      "oauthAuthorize": {
        "loading": "載入中...",
        "loadError": "載入授權詳情失敗。",
        "authorizeError": "授權失敗。",
        "denyError": "授權拒絕失敗。"
      },
      "oauth": {
        "disconnect": {
          "success": "服務商已成功中斷。",
          "failure": "無法中斷服務商。請重試。"
        }
      },
      "confirmAccess": {
        "failure": "無法確認存取。請檢查密碼並重試。"
      },
      "setEmail": {
        "success": "確認郵件已發送到您的新郵箱地址，請檢查收件匣。",
        "failure": "無法更新電子郵件地址，請重試。"
      },
      "confirmAccessEmail": {
        "sent": "確認碼已傳送到您的電子郵件。",
        "failure": "無法傳送確認郵件。請重試。"
      },
      "confirmAccessCode": {
        "failure": "確認碼無效或已過期。"
      },
      "import": {
        "started": "%{type} 匯入已開始...",
        "finished": "%{type} 匯入成功完成。",
        "failed": "%{type} 匯入失敗: %{info}"
      },
      "buybackSync": {
        "started": "正在同步你的可回購承諾...",
        "success": "你的可回購承諾已同步。",
        "failure": "無法同步你的可回購承諾。",
        "detailsSuccess": "你的可回購承諾的價格和保險已是最新。"
      },
      "syncExtension": {
        "started": "正在同步您的機庫...",
        "success": "您的機庫已同步。",
        "failure": "您的機庫無法同步。",
        "cancelled": "機庫同步已被取消。",
        "pageNotRecognised": "RSI 的頁面與 FleetYards 預期的不同，因此同步已停止，未做任何變更。",
        "nothingToSync": "FleetYards 在您的 RSI 機庫中未找到任何艦船、塗裝或組件，因此未做任何變更。",
        "onlySkippedItems": "您的 RSI 機庫中只有本次同步設定為略過的塗裝或機庫裝飾，因此未做任何變更。",
        "nothingReadable": "您的 RSI 機庫中有部分物品無法讀取，且 FleetYards 未找到其他內容，因此未做任何變更。",
        "notLoggedIn": "您需要在<a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a>登入以同步您的機庫。"
      },
      "admin": {
        "form": {
          "created": "已建立。",
          "updated": "變更已儲存。"
        },
        "importLoaders": {
          "started": "%{name} 已開始。",
          "failed": "無法開始 %{name}。"
        },
        "supporterContributions": {
          "patreonSyncStarted": "Patreon 同步已開始。請在一分鐘後重新整理以查看匯入的支持者。"
        },
        "imports": {
          "cleaned": "匯入已標記為失敗",
          "cleanedUp": {
            "one": "已將 %{count} 個匯入標記為失敗",
            "other": "已將 %{count} 個匯入標記為失敗"
          },
          "noneRunning": "所選內容中沒有仍在執行的匯入",
          "cleanupError": "無法清理該匯入"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "清空這艘飛船的貨物？所有記錄都會被刪除。",
            "success": "貨物已清空。",
            "failure": "無法清空貨物。"
          }
        },
        "transfer": {
          "needsAnswer": "對方需要先接受。庫存現在即離開你的倉庫，若被拒絕則會退回。",
          "create": {
            "failure": "無法傳送轉移"
          },
          "resolve": {
            "failure": "無法更新轉移"
          },
          "reportHint": "檢舉會拒絕該轉移並退回貨物，同時阻止該傳送者再次聯絡你。"
        }
      },
      "adminNotifications": {
        "read": "通知已標示為已讀",
        "unread": "通知已標示為未讀",
        "archived": "通知已封存",
        "unarchived": "通知已移回收件匣",
        "readAll": "所有通知已標示為已讀",
        "destroyed": "通知已刪除",
        "destroyedAll": "所有通知已刪除",
        "error": "發生錯誤",
        "bulk": {
          "read": {
            "one": "%{count} 則通知已標示為已讀",
            "other": "%{count} 則通知已標示為已讀"
          },
          "unread": {
            "one": "%{count} 則通知已標示為未讀",
            "other": "%{count} 則通知已標示為未讀"
          },
          "archived": {
            "one": "%{count} 則通知已封存",
            "other": "%{count} 則通知已封存"
          },
          "unarchived": {
            "one": "%{count} 則通知已移回收件匣",
            "other": "%{count} 則通知已移回收件匣"
          },
          "destroyed": {
            "one": "%{count} 則通知已刪除",
            "other": "%{count} 則通知已刪除"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "通知設定已儲存。",
            "failure": "無法儲存通知設定。"
          }
        },
        "mission": {
          "publish": {
            "success": "任務已發布 — 艦隊現在可以看到它。",
            "failure": "無法發布任務。"
          },
          "create": {
            "success": "任務已建立。",
            "failure": "無法建立任務。"
          },
          "update": {
            "success": "任務已更新。",
            "failure": "無法更新任務。"
          },
          "archive": {
            "success": "任務已封存。",
            "failure": "無法封存任務。"
          },
          "unarchive": {
            "success": "任務已還原。",
            "failure": "無法還原任務。"
          },
          "destroy": {
            "success": "任務已刪除。",
            "failure": "無法刪除任務。",
            "confirm": "這會永久刪除該任務及其所有隊伍、飛船與席位。此操作無法復原。"
          }
        },
        "missionTeam": {
          "create": {
            "success": "隊伍已新增。",
            "failure": "無法新增隊伍。"
          },
          "update": {
            "success": "隊伍已更新。",
            "failure": "無法更新隊伍。"
          },
          "destroy": {
            "success": "隊伍已移除。",
            "failure": "無法移除隊伍。"
          }
        },
        "missionShip": {
          "create": {
            "success": "飛船已新增。",
            "failure": "無法新增飛船。"
          },
          "update": {
            "success": "飛船已更新。",
            "failure": "無法更新飛船。"
          },
          "destroy": {
            "success": "飛船已移除。",
            "failure": "無法移除飛船。"
          },
          "duplicate": {
            "success": "飛船已複製。",
            "failure": "無法複製此飛船。"
          }
        },
        "missionSlot": {
          "create": {
            "success": "席位已新增。",
            "failure": "無法新增席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "無法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "無法移除席位。"
          }
        },
        "event": {
          "create": {
            "success": "活動已建立。",
            "failure": "無法建立活動。"
          },
          "update": {
            "success": "活動已更新。",
            "failure": "無法更新活動。"
          },
          "archive": {
            "success": "活動已封存。",
            "failure": "無法封存活動。",
            "confirm": "要封存此活動嗎？成員將不會再於即將舉行的清單中看到它。"
          },
          "unarchive": {
            "success": "活動已從封存還原。",
            "failure": "無法還原活動。"
          },
          "syncToDiscord": {
            "success": "活動已推送到 Discord。",
            "failure": "無法將活動推送到 Discord。",
            "discord_missing_permissions": "Discord 拒絕了請求：機器人缺少在你的伺服器中所需的權限。艦隊的 Discord 設定中會說明缺少哪一項。"
          },
          "destroy": {
            "success": "活動已刪除。",
            "failure": "無法刪除活動。",
            "confirm": "這會永久刪除該活動。此操作無法復原。"
          },
          "publish": {
            "success": "活動已發布 — 報名現已開放。",
            "failure": "無法發布活動。"
          },
          "lockSignups": {
            "success": "報名已鎖定。",
            "failure": "無法鎖定報名。"
          },
          "unlockSignups": {
            "success": "報名已重新開放。",
            "failure": "無法重新開放報名。"
          },
          "start": {
            "success": "活動已開始。",
            "failure": "無法開始活動。"
          },
          "complete": {
            "success": "活動已標示為完成。",
            "failure": "無法完成活動。"
          },
          "cancel": {
            "success": "活動已取消。",
            "failure": "無法取消活動。",
            "confirm": "要取消此活動嗎？參加者將會收到通知。"
          }
        },
        "eventSignup": {
          "create": {
            "success": "您已報名。",
            "failure": "無法報名。"
          },
          "update": {
            "success": "報名已更新。",
            "failure": "無法更新報名。"
          },
          "withdraw": {
            "success": "您已退出此活動。",
            "failure": "無法取消報名。",
            "confirm": "要退出此活動嗎？"
          },
          "kick": {
            "success": "報名已移除。",
            "failure": "無法移除報名。",
            "confirm": "要移除這位成員的報名嗎？"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "角色已授予。",
            "failure": "無法授予角色。"
          },
          "destroy": {
            "success": "角色已撤銷。",
            "failure": "無法撤銷角色。",
            "confirm": "要撤銷 %{username} 在此活動的角色嗎？"
          }
        },
        "eventTeam": {
          "create": {
            "success": "隊伍已新增。",
            "failure": "無法新增隊伍。"
          },
          "update": {
            "success": "隊伍已更新。",
            "failure": "無法更新隊伍。"
          },
          "destroy": {
            "success": "隊伍已移除。",
            "failure": "無法移除隊伍。",
            "confirm": "要移除此隊伍及其所有飛船與席位嗎？"
          }
        },
        "eventShip": {
          "create": {
            "success": "飛船已新增。",
            "failure": "無法新增飛船。"
          },
          "update": {
            "success": "飛船已更新。",
            "failure": "無法更新飛船。"
          },
          "destroy": {
            "success": "飛船已移除。",
            "failure": "無法移除飛船。",
            "confirm": "要移除此飛船及其席位嗎？"
          }
        },
        "eventSlot": {
          "create": {
            "success": "席位已新增。",
            "failure": "無法新增席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "無法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "無法移除席位。"
          }
        },
        "contract": {
          "create": {
            "success": "合約已建立",
            "failure": "無法建立合約"
          },
          "update": {
            "success": "合約已儲存",
            "failure": "無法儲存合約"
          },
          "item": {
            "create": {
              "failure": "無法新增貨物"
            },
            "destroy": {
              "failure": "無法移除貨物"
            },
            "update": {
              "failure": "無法修改貨物"
            }
          }
        },
        "contracts": {
          "deliverHint": "從你的倉庫發送貨物並選擇此合約，交付才會計入進度。",
          "expiredHint": "此合約已過期，不再接受新的交付。已在途中的交付在被接收後仍會計入進度。"
        }
      },
      "notifications": {
        "read": "通知已標示為已讀",
        "unread": "通知已標示為未讀",
        "archived": "通知已封存",
        "unarchived": "通知已移回收件匣",
        "readAll": "所有通知已標示為已讀",
        "destroyed": "通知已刪除",
        "destroyedAll": "所有通知已刪除",
        "actionDone": "完成",
        "actionFailed": "操作沒有成功 - 這則通知可能已經過期",
        "error": "發生錯誤",
        "bulk": {
          "read": {
            "one": "%{count} 則通知已標示為已讀",
            "other": "%{count} 則通知已標示為已讀"
          },
          "unread": {
            "one": "%{count} 則通知已標示為未讀",
            "other": "%{count} 則通知已標示為未讀"
          },
          "archived": {
            "one": "%{count} 則通知已封存",
            "other": "%{count} 則通知已封存"
          },
          "unarchived": {
            "one": "%{count} 則通知已移回收件匣",
            "other": "%{count} 則通知已移回收件匣"
          },
          "destroyed": {
            "one": "%{count} 則通知已刪除",
            "other": "%{count} 則通知已刪除"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "匯入已取消",
          "error": "無法取消這次匯入"
        }
      },
      "payouts": {
        "participantAddedUser": "已新增 %{name}（已連結 FleetYards 帳戶）",
        "participantAddedGuest": "已將 %{name} 新增為訪客",
        "invalidAmount": "請輸入金額，例如 1,500.50",
        "currencyUpdated": "貨幣已更新",
        "tourArchived": "行程已封存",
        "tourUnarchived": "行程已還原",
        "tourDeleted": "行程已刪除",
        "deleteTourConfirm": "刪除此行程？此操作無法復原。",
        "archiveTourConfirm": "封存此行程？它將從清單中移除，但帳目會保留。",
        "entryCreated": "已紀錄",
        "entryUpdated": "已更新",
        "destroyEntryConfirm": "刪除此條目？此操作無法復原。",
        "entryDestroyed": "已刪除",
        "participantAdded": "已新增參與者",
        "participantRemoved": "已移除參與者",
        "participantHasEntries": "請先刪除該參與者的紀錄",
        "settled": "分帳已計算",
        "reopened": "已重新開啟",
        "tourCreated": "行程已建立",
        "tourCreateFailure": "無法建立行程。",
        "tourJoined": "你已加入該行程",
        "settleConfirm": "計算分帳並鎖定帳簿？在重新開啟之前將無法修改紀錄。",
        "reopenConfirm": "重新開啟帳簿？目前的分帳清單將被捨棄。",
        "participantNeedsName": "請輸入使用者名稱或名稱",
        "weightUpdated": "份額已更新",
        "joinRequested": "你的申請已送出",
        "joinRequestWithdrawn": "申請已撤回",
        "joinRequestApproved": "申請已通過",
        "joinRequestDeclined": "申請已拒絕",
        "expenseApproved": "支出已核准",
        "expenseDeclined": "支出已拒絕",
        "pendingReview": "%{count} 筆支出待審核"
      },
      "dockAddition": {
        "create": {
          "failure": "無法新增該飛船。"
        },
        "destroy": {
          "failure": "無法移除該飛船。"
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "無法建立容量條目。"
        },
        "update": {
          "failure": "無法儲存容量條目。"
        },
        "destroy": {
          "failure": "無法刪除容量條目。"
        }
      },
      "dock": {
        "create": {
          "failure": "無法建立停靠點。"
        },
        "update": {
          "failure": "無法儲存停靠點。"
        },
        "destroy": {
          "failure": "無法刪除停靠點。"
        }
      },
      "relationships": {
        "user": {
          "addHint": "輸入你想新增的使用者名稱。對方需要同意。"
        },
        "fleet": {
          "addHint": "輸入你想結盟的艦隊識別碼。對方管理員需要同意。"
        }
      },
      "friends": {
        "request": {
          "success": "請求已發送",
          "failure": "無法發送請求"
        },
        "accept": {
          "success": "請求已接受",
          "failure": "無法接受請求"
        },
        "decline": {
          "success": "請求已拒絕",
          "failure": "無法拒絕請求"
        },
        "ignore": {
          "success": "請求已忽略",
          "failure": "無法忽略請求"
        },
        "remove": {
          "success": "已移除",
          "failure": "無法移除"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "請求已發送",
          "failure": "無法發送請求"
        },
        "accept": {
          "success": "請求已接受",
          "failure": "無法接受請求"
        },
        "decline": {
          "success": "請求已拒絕",
          "failure": "無法拒絕請求"
        },
        "ignore": {
          "success": "請求已忽略",
          "failure": "無法忽略請求"
        },
        "remove": {
          "success": "已移除",
          "failure": "無法移除"
        }
      },
      "vehiclePlaque": {
        "removeConfirm": "要移除這艘船的命名銘牌嗎？",
        "downloadFailure": "銘牌未能儲存為圖片",
        "failure": "銘牌未能儲存"
      },
      "vehicleOverview": {
        "image": {
          "success": "圖片已儲存",
          "failure": "無法儲存圖片"
        },
        "paint": {
          "failure": "無法套用塗裝"
        },
        "setting": {
          "failure": "無法儲存設定"
        },
        "location": {
          "failure": "無法儲存位置"
        }
      },
      "vehicleLog": {
        "create": {
          "success": "日誌條目已新增",
          "failure": "無法新增日誌條目"
        },
        "update": {
          "success": "日誌條目已儲存",
          "failure": "無法儲存日誌條目"
        },
        "destroy": {
          "failure": "無法刪除日誌條目"
        },
        "defaultUpdate": {
          "failure": "無法儲存設定"
        }
      },
      "vehicleLoadout": {
        "failure": "無法儲存裝配。"
      },
      "hangarPledgeItems": {
        "addedToInventory": {
          "other": "已將 %{count} 項加入 %{inventory}"
        },
        "addToInventoryFailed": "無法將物品加入庫存。"
      }
    }
  }
}
